import { c as _c } from "react/compiler-runtime";
import { PhysicalProductItemErrorsType } from 'modules/stores/store/content/product/types/product-interface';
import { getPhysicalProductCheckoutErrorChecker, getThankYouErrorChecker, getThumbnailErrorChecker } from 'modules/stores/store/utils/get-error-checkers';
import { useFormErrorMessageInTabs } from 'modules/stores/store/utils/use-form-error-message-in-tabs';
import { PhysicalProductTabEnum, tabLocoKeys } from '../enum/physical-product-tab-enum';
import { getPhysicalProductError } from '../utls/get-physical-product-error';
export const useErrorMessageInTabs = () => {
  const $ = _c(2);
  const {
    formErrorMessage: formErrorMessageCommon
  } = useFormErrorMessageInTabs();
  const getTabsWithErrors = _temp;
  let t0;
  if ($[0] !== formErrorMessageCommon) {
    const formErrorMessage = t1 => {
      const {
        errors: errors_0
      } = t1;
      const tabsErrorsMap = getTabsWithErrors({
        errors: errors_0
      });
      return formErrorMessageCommon({
        tabsErrorsMap,
        tabsLocoKeys: tabLocoKeys
      });
    };
    t0 = {
      getTabsWithErrors,
      formErrorMessage
    };
    $[0] = formErrorMessageCommon;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};
function _temp(t0) {
  const {
    errors
  } = t0;
  const hasThumbnailError = getThumbnailErrorChecker(errors);
  const hasCheckoutError = getPhysicalProductCheckoutErrorChecker(errors);
  const hasThankYouError = getThankYouErrorChecker(errors);
  const hasProductError = getPhysicalProductError(errors);
  return {
    [PhysicalProductTabEnum.thumbnail]: hasThumbnailError,
    [PhysicalProductTabEnum.checkout]: hasCheckoutError,
    [PhysicalProductTabEnum.physical_product]: hasProductError,
    [PhysicalProductTabEnum.thank_you]: hasThankYouError
  };
}